export default __webpack_public_path__ + "static/media/blueslider4.efe95198.png";